var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup301(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.141 13.3541L16.5736 20.7549L13.3217 16.5429L11.2014 18.1789L16.162 24.6059L18.2801 22.9604L27.8454 15.5607L26.141 13.3541Z",
    fill: "#00AC4F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_65_112",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 39
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H38V38.6653H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_65_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6464 21.8793C39.1887 11.5781 32.0721 1.94232 21.7846 0.398988C11.4961 -1.14434 1.87294 5.98066 0.330664 16.2839C-1.21056 26.584 5.90602 36.2198 16.1935 37.7642C17.0536 37.8926 17.8505 37.302 17.981 36.4409C18.1084 35.5808 17.5189 34.7828 16.6598 34.6523C8.08415 33.3647 2.15402 25.3333 3.43732 16.7482C4.71957 8.16195 12.7436 2.22445 21.3183 3.50881C29.8929 4.79527 35.8241 12.8267 34.5408 21.4129C33.8386 26.1018 31.1246 30.1381 27.1357 32.5489L27.94 27.1725C28.0674 26.3113 27.4779 25.5144 26.6188 25.3828C25.7587 25.2544 24.9618 25.8429 24.8313 26.7061L23.5238 35.445C23.3953 36.3061 23.9849 37.1041 24.845 37.2346L33.5638 38.5411C34.4239 38.6695 35.2208 38.079 35.3514 37.2189C35.4788 36.3577 34.8892 35.5597 34.0302 35.4292L29.5371 34.7554C33.8944 31.8193 36.8494 27.202 37.6464 21.8793Z",
    fill: "#00AC4F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup301);
export default __webpack_public_path__ + "static/media/Group 301.88cccffed5f097627616a9230adc14bd.svg";
export { ForwardRef as ReactComponent };